/**
 * The HR Connect — official logo.
 * Two modes:
 *  - default → full horizontal lockup (icon + wordmark + tagline)
 *  - iconOnly → standalone HC monogram (for compact placements)
 *
 * Backward-compat props (showWordmark / withTagline) are ignored — the
 * official lockup already includes the wordmark and tagline.
 */
export default function Logo({ className = "", iconOnly = false, showWordmark = true }) {
    const useIcon = iconOnly || !showWordmark;

    if (useIcon) {
        return (
            <span
                className={`inline-flex items-center ${className}`}
                aria-label="The HR Connect"
                data-testid="hc-logo"
            >
                <img
                    src="/hire-connect-icon.png"
                    alt="The HR Connect"
                    width="40"
                    height="40"
                    className="h-10 w-10 object-contain"
                />
            </span>
        );
    }

    return (
        <span
            className={`inline-flex items-center ${className}`}
            aria-label="The HR Connect — Talent & Benefits Advisory"
            data-testid="hc-logo"
        >
            <img
                src="/hire-connect-logo.png"
                alt="The HR Connect — Talent & Benefits Advisory"
                className="h-10 md:h-12 w-auto object-contain"
            />
        </span>
    );
}
